import { Contact } from "./module/contact/contact";
import { GameInfo } from "./module/game-info/game-info";
import { HowToPlay } from "./module/how-to-play/how-to-play";
import { Logo } from "./module/logo/logo";
import { MainFeatures } from "./module/main-features/main-features";
import { Nav } from "./module/nav/nav";
import { QRCode } from "./module/qr-coode/qr-code";

function App() {
  return (
    <div>
      <main>
        <Nav />
        <Logo />
        <QRCode />
        <HowToPlay />
        <MainFeatures />
        <GameInfo />
        <Contact />
      </main>
      <footer className="footer">
        <label>© EverMines 2025</label>
      </footer>
    </div>
  );
}

export default App;
